import { render, staticRenderFns } from "./RecordAwards.vue?vue&type=template&id=7e995f88&scoped=true&"
import script from "./RecordAwards.vue?vue&type=script&lang=js&"
export * from "./RecordAwards.vue?vue&type=script&lang=js&"
import style0 from "./RecordAwards.vue?vue&type=style&index=0&id=7e995f88&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e995f88",
  null
  
)

export default component.exports